import { render } from "./ApprovePayout.vue?vue&type=template&id=2b1c1d77"
import script from "./ApprovePayout.vue?vue&type=script&lang=js"
export * from "./ApprovePayout.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3760926026/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__